import { roleAccent } from "./organigramaColors";

export const ireneRole = {
  id: "irene",
  section: "1.1",
  name: "Irene",
  subtitle: "EXECUTIVE ROLE CHARTER",
  role: "Founder, Chief Product, Commercial & Partnerships Officer (CPCPO)",
  reportaALabel: "Reports to",
  reportaA: "Executive Chair",
  accent: roleAccent("irene"),
  foco: [],
  noFoco: [],
  propositoLabel: "Purpose of the Role",
  proposito:
    "The Founder, Chief Product, Commercial & Partnerships Officer (CPCPO) is responsible for defining the Group's commercial, product and partnership strategy to ensure sustainable growth and long-term competitiveness.\n\nThe role exists to strengthen the market position of Stage Design Studio and No Man's Label through customer development, product excellence, innovation and strategic relationships with clients, suppliers and international partners.",
  misionLabel: "Mission",
  mision:
    "Build the future of the Group by creating differentiated products, developing strategic customer relationships and identifying new business opportunities that generate sustainable and profitable growth.",
  scopeLabel: "Scope of Responsibility",
  scopeIntro: "The Founder & CPCPO has executive responsibility for:",
  scopeItems: [
    "Commercial Strategy",
    "Business Development",
    "Product Strategy",
    "Product Development",
    "Design Direction",
    "Strategic Partnerships",
    "Customer Development",
    "Brand Positioning",
    "Market Expansion",
  ],
  scopeNote:
    "The Founder collaborates closely with the COFO to ensure that commercial opportunities can be executed efficiently, profitably and operationally.",
  responsabilidadesLabel: "Key Responsibilities",
  responsabilidades: [
    {
      title: "1. Growth Strategy",
      intro:
        "Define the long-term growth strategy for Stage Design Studio and No Man's Label.",
      items: [
        "Define the strategic positioning of both companies.",
        "Identify new markets, customers and business opportunities.",
        "Develop new industrial partnerships that strengthen the competitiveness of the Group.",
        "Evaluate new business models, product categories and growth opportunities.",
        "Promote long-term sustainable growth.",
      ],
    },
    {
      title: "2. Commercial Leadership",
      intro: "Lead the Group's commercial strategy and customer development.",
      items: [
        "Define the commercial strategy.",
        "Lead and develop the Business Development team.",
        "Prioritise customers, markets and business opportunities.",
        "Lead strategic customer development.",
        "Support key commercial negotiations where executive involvement creates value.",
        "Build long-term customer relationships.",
        "Protect customer satisfaction and long-term commercial partnerships.",
      ],
    },
    {
      title: "3. Product & Brand Leadership",
      intro:
        "Protect the identity, competitiveness and long-term value of the Group's products and brands.",
      items: [
        "Define the product DNA.",
        "Lead the overall product direction together with the Head of Design.",
        "Define the product and sourcing strategy required to maximise competitiveness, quality and profitability.",
        "Ensure that collections balance creativity, commercial appeal and profitability.",
        "Protect the positioning and long-term competitiveness of the Group's brands.",
      ],
    },
    {
      title: "4. Strategic Partnerships",
      intro: "Develop relationships that strengthen the Group's competitive position.",
      items: [
        "Maintain executive relationships with key customers and international partners.",
        "Represent the Group in strategic meetings, international travel and industry events.",
        "Develop long-term industrial and commercial partnerships.",
        "Strengthen the Group's international network.",
      ],
    },
    {
      title: "5. Leadership & Culture",
      intro:
        "Promote a commercial and product organisation capable of supporting the long-term ambitions of the Group.",
      items: [
        "Inspire the organisation through vision and leadership.",
        "Develop commercial talent.",
        "Foster innovation and continuous improvement.",
        "Encourage collaboration across departments.",
        "Promote a customer-focused culture.",
        "Strengthen the Group's entrepreneurial mindset.",
      ],
    },
    {
      title: "6. Governance",
      intro:
        "Where responsibilities overlap, strategic direction remains with the Executive Chair while operational execution remains the responsibility of the COFO.",
      items: [
        "Participate in the Executive Management Team.",
        "Define the commercial and product priorities of the Group.",
        "Align commercial strategy with the long-term objectives of the business.",
        "Support strategic decision-making through market knowledge and customer insight.",
      ],
    },
  ],
  governanceBoundariesLabel: "Governance Boundaries",
  governanceBoundariesIntro:
    "To ensure clear accountability across the Executive Team:",
  governanceBoundaries: [
    "Commercial strategy, customer development and product direction are the responsibility of the Founder & CPCPO.",
    "Operational execution, planning and financial discipline remain the responsibility of the COFO.",
    "Organisational strategy, governance and long-term corporate direction remain the responsibility of the Executive Chair.",
    "The Founder provides strategic direction to the commercial and product organisation but does not manage day-to-day operational execution.",
    "Commercial growth must always be supported by operational capability and financial discipline.",
  ],
  kpiGroups: [
    {
      title: "Commercial",
      items: [
        "SDS Revenue Growth",
        "NML Revenue Growth",
        "New Customers Acquired",
        "Growth of Existing Customers",
        "Customer Retention",
        "Commercial Margin by Customer",
      ],
    },
    {
      title: "Product",
      items: [
        "Sample Hit Rate",
        "Collection Performance",
        "Product Profitability",
        "Time-to-Market",
      ],
    },
    {
      title: "Strategic Development",
      items: [
        "New Strategic Partnerships",
        "Market Expansion",
        "Customer Satisfaction",
        "Brand Positioning",
      ],
    },
  ],
  kpis: [],
  kpisLabel: "Key Performance Indicators",
  leadershipExpectationsLabel: "Leadership Expectations",
  leadershipExpectations:
    "The Founder & CPCPO is expected to build the future of the Group through innovation, customer relationships and product excellence.\n\nLeadership is measured by the ability to create long-term competitive advantage, strengthen the commercial organisation and develop products that reinforce the Group's market position.",
  decisionMatrixLabel: "Executive Decision Matrix",
  decisionMatrix: {
    headers: ["Area", "Final Decision", "CPCPO"],
    rows: [
      ["Commercial Strategy", "Founder & EC", "Final Owner"],
      ["Product Strategy", "Founder", "Final Owner"],
      ["Customer Development", "Founder", "Final Owner"],
      ["Pricing Strategy", "Founder & EC", "Final Owner"],
      ["Brand Positioning", "Founder", "Final Owner"],
      ["Strategic Partnerships", "Founder", "Final Owner"],
      ["Business Development", "Founder", "Final Owner"],
      ["Product DNA", "Founder", "Final Owner"],
      ["Product Development", "Founder + Head of Design", "Final Owner"],
      ["Commercial Organisation", "Founder", "Final Owner"],
      ["Operational Planning", "COFO", "Support"],
      ["Production", "COFO", "Support"],
      ["Logistics", "COFO", "Support"],
      ["Budget", "Founder & EC", "Recommendation"],
    ],
  },
};
